import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import LoginPage from "@/pages/Login";
import RegisterPage from "@/pages/Register";
import DashboardPage from "@/pages/Dashboard";
import DataEntryPage from "@/pages/DataEntry";
import HistoryPage from "@/pages/History";
import SettingsPage from "@/pages/Settings";
import UsersPage from "@/pages/Users";
import ItemDetailPage from "@/pages/ItemDetail";
import PersonnelPage from "@/pages/Personnel";
import FuelAnalysisPage from "@/pages/FuelAnalysis";

function AuthedRoute({ element, roles }) {
  return (
    <ProtectedRoute roles={roles}>
      <Layout>{element}</Layout>
    </ProtectedRoute>
  );
}

function App() {
  // Remove the platform-injected badge if present
  useEffect(() => {
    const remove = () => {
      const el = document.getElementById("emergent-badge");
      if (el) el.remove();
    };
    remove();
    const iv = setInterval(remove, 500);
    return () => clearInterval(iv);
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/" element={<AuthedRoute element={<DashboardPage />} />} />
          <Route path="/item/:itemKey" element={<AuthedRoute element={<ItemDetailPage />} />} />
          <Route path="/entry" element={<AuthedRoute element={<DataEntryPage />} roles={["admin", "editor"]} />} />
          <Route path="/history" element={<AuthedRoute element={<HistoryPage />} />} />
          <Route path="/settings" element={<AuthedRoute element={<SettingsPage />} roles={["admin"]} />} />
          <Route path="/users" element={<AuthedRoute element={<UsersPage />} roles={["admin"]} />} />
          <Route path="/personel" element={<AuthedRoute element={<PersonnelPage />} />} />
          <Route path="/fuel" element={<AuthedRoute element={<FuelAnalysisPage />} roles={["admin", "editor", "viewer"]} />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
